import { render, staticRenderFns } from "./paySetting.vue?vue&type=template&id=d7a4c83c&scoped=true"
import script from "./paySetting.vue?vue&type=script&lang=js"
export * from "./paySetting.vue?vue&type=script&lang=js"
import style0 from "./paySetting.vue?vue&type=style&index=0&id=d7a4c83c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a4c83c",
  null
  
)

export default component.exports